import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import axios from 'axios';
import moment from 'moment';
import ActionTable from './common/Table';
import { CommonConfig } from '../../../../config/common-config';
import SearchBox from '../../../../components/table/SearchBox';
// import SearchBox from '../../../components/table/SearchBox';
// import AdminInvoiceView from '../Admin/create';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

const OpenItec = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setRows] = useState([]);
    const userData = JSON.parse(sessionStorage.getItem('user'));
    const buyerType = userData.result.data.userType;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const [pageDetails, setPageDetails] = useState('');
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    useEffect(() => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-itecothers-openservice?page=${page}&size=10&sort=id,desc`, axiosConfig)
            .then((res) => {
                // formatDate(res.data.content);
                setRows(res.data.content);
                console.log('Responseeeee', res);
                setPageDetails(res.data);
                setLoading(false);
                if (res.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (res.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            });
    }, [userToken, page]);

    // function formatDate(props) {
    //     return props.map((element) => {
    //         const tempStartDate = element.invoiceDate;
    //         const tempEndDate = element.dateModified;
    //         const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
    //         const formatStartDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
    //         const formatEndDate = new Date(tempEndDate.replace(pattern, '$3-$2-$1'));
    //         element.invoiceDate = moment(formatStartDate).format('DD-MM-YYYY');
    //         element.dateModified = moment(formatEndDate).format('DD-MM-YYYY');
    //     });
    // }

    // HeadCells
    const headcells = [
        { id: 'firstname', label: 'First Name' },
        { id: 'lastname', label: 'Last Name' },
        { id: 'employeeId', label: 'Employee ID' },
        // { id: 'invoiceDate', label: 'Invoice Date' },
        { id: 'openservices', label: 'No. of ongoing services' },
        // { id: 'dateModified', label: 'Email sent Date' },
    ];

    const history = useHistory();

    const handleSearchQuery = (data) => {
        setSearchQuery(data);
    };

    const classes = useStyles();

    // filtered row based on search
    const filteredRow = searchQuery
        ? rows.filter((row) => {
              const query = searchQuery.toLowerCase().trim();
              return headcells
                  .map((col) => col.id)
                  .some((key) => {
                      if (row[key]) {
                          return row[key].toString().toLowerCase().includes(query);
                      } else {
                          return false;
                      }
                  });
          })
        : rows;

    if (buyerType === 'ADMIN' || buyerType === 'CORETEAM') {
        // return <AdminInvoiceView />;
        return;
    }

    return (
        <Card className="custom-table">
            <CardContent className="card-title-display">
                <Grid item xs={12} sm={8}>
                    <Typography className="card-title">Open @ ITeC</Typography>
                </Grid>
                <Grid item xs={12} sm={4} className="card-search">
                    <div className="search-field">
                        <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                    </div>
                </Grid>
            </CardContent>
            <CardContent className="card-table-display">
                {rows && filteredRow.length > 0 ? (
                    <>
                        <ActionTable
                            headcells={headcells}
                            rows={filteredRow}
                            post="superAdmin"
                            mode="view"
                            action
                            pageDetails={pageDetails}
                            prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                            loading={loading}
                            handleCount={handleCount}
                        />
                    </>
                ) : (
                    <div className={classes.noRecord}>
                        <h1>No records to display</h1>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default OpenItec;
